/* @ngInject */
export default class ColumnConfigController {
    constructor($scope, $timeout, currentColumns, SensorService, onUpdate, onClose) {
        this.$scope = $scope;
        this.$timeout = $timeout;
        this.SensorService = SensorService;
        this.onUpdate = onUpdate;
        this.onClose = onClose;
        
        // Initialize with current columns or empty array
        this.labelColumns = currentColumns.length > 0 ? [...currentColumns] : [''];
        
        // Autocomplete state
        this.availableLabelKeys = [];
        this.filteredLabelKeys = {};
        this.showKeysDropdown = {};
        this.selectedKeyIndex = {};
        this.isSelecting = false; // Flag to prevent blur when selecting
    }

    $onInit() {
        this.fetchLabelKeys();
    }

    fetchLabelKeys() {
        this.SensorService.listLabelKeys().then(response => {
            // Only use device label keys (not project label keys)
            // since custom columns show device label values
            const keyMap = new Map();
            
            if (response.deviceLabelKeys) {
                response.deviceLabelKeys.forEach(item => {
                    // Filter out 'name' since it's already a default column
                    if (item.key !== 'name') {
                        keyMap.set(item.key, {
                            key: item.key,
                            deviceCount: item.deviceCount
                        });
                    }
                });
            }
            
            // Convert map to array and sort by device count (descending)
            this.availableLabelKeys = Array.from(keyMap.values())
                .sort((a, b) => b.deviceCount - a.deviceCount);
            
            this.$scope.$applyAsync();
        }).catch(error => {
            // eslint-disable-next-line no-console
            console.error('Failed to fetch label keys:', error);
            this.availableLabelKeys = [];
        });
    }

    onKeyInputFocus(index) {
        this.filterLabelKeys(index);
        this.showKeysDropdown[index] = true;
    }

    onKeyInputBlur(index) {
        // Don't hide dropdown if we're selecting an item
        if (this.isSelecting) {
            return;
        }
        
        // Delay to allow click on dropdown item
        this.$timeout(() => {
            if (!this.isSelecting) {
                this.showKeysDropdown[index] = false;
                this.selectedKeyIndex[index] = -1;
            }
        }, 200);
    }

    onKeyInputChange(index) {
        this.filterLabelKeys(index);
        this.selectedKeyIndex[index] = -1;
    }

    filterLabelKeys(index) {
        const searchTerm = (this.labelColumns[index] || '').toLowerCase();
        this.filteredLabelKeys[index] = this.availableLabelKeys.filter(item =>
            item.key.toLowerCase().includes(searchTerm)
        );
    }

    selectLabelKey(index, key, $event) {
        if ($event) {
            $event.preventDefault();
            $event.stopPropagation();
        }
        
        this.isSelecting = true;
        this.labelColumns[index] = key;
        this.showKeysDropdown[index] = false;
        this.selectedKeyIndex[index] = -1;
        
        // Reset the flag after a short delay
        this.$timeout(() => {
            this.isSelecting = false;
        }, 100);
        
        this.$scope.$applyAsync();
    }

    getCountDisplayText(count) {
        if (count >= 1000) {
            return `${(count / 1000).toFixed(1)}k`;
        }
        return count.toString();
    }

    addColumn() {
        if (this.labelColumns.length < 10) {
            this.labelColumns.push('');
        }
    }

    removeColumn(index) {
        this.labelColumns.splice(index, 1);
        if (this.labelColumns.length === 0) {
            this.labelColumns = [''];
        }
    }
    
    canAddMoreColumns() {
        return this.labelColumns.length < 10;
    }

    clear() {
        this.labelColumns = [''];
        this.apply();
    }

    apply() {
        // Filter out empty columns
        const validColumns = this.labelColumns.filter(col => col.trim() !== '');
        this.onUpdate(validColumns);
        this.onClose();
    }
}

